<template>
  <div>
    <p v-if="title" class="mb-1.5 title">{{ title }}</p>
    <p v-if="subTitle" class="mb-5 subtitle">{{ subTitle }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.title {
  font-size: 18px;
  font-weight: 500;
  line-height: 21px;
}

.subtitle {
  color: #979797;
  font-weight: 400;
  font-size: 14px;
}
</style>